function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M36.543 18.658v7.848c0 .324-.071.432-.43.432-1.36-.036-2.72 0-4.08 0-.286 0-.357-.072-.357-.36V10.702c0-.288.071-.36.358-.36h4.116c.322 0 .393.108.393.396v7.92z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M30.208 15.778v10.764c0 .36-.107.432-.465.432-1.36-.036-2.72 0-4.08 0-.287 0-.358-.072-.358-.36V4.906c0-.288.071-.36.358-.36h4.116c.322 0 .393.072.393.396.036 3.6.036 7.2.036 10.836z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M19.041 13.438V.442c0-.36.108-.468.43-.432 1.36.036 2.684.036 4.044 0 .322 0 .358.072.358.396v26.208c0 .324-.071.396-.394.36-1.36 0-2.72-.036-4.08 0-.322 0-.394-.108-.394-.396.036-4.392.036-8.784.036-13.14z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M17.538 16.894v9.576c0 .396-.107.468-.501.468-1.324-.036-2.649 0-4.009 0-.286 0-.358-.072-.358-.36V7.102c0-.288.108-.36.358-.36 1.36 0 2.72.036 4.08 0 .323 0 .394.108.394.396 0 3.276.036 6.516.036 9.756z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M11.167 14.518v12.024c0 .324-.072.432-.43.432-1.36-.036-2.72 0-4.08 0-.286 0-.358-.072-.358-.36V2.422c0-.288.072-.36.358-.36 1.36 0 2.72.036 4.08 0 .323 0 .43.072.43.432v12.024z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M0 15.454c1.503 0 3.042 0 4.546-.036.25 0 .286.072.286.288v10.908c0 .252-.107.288-.322.288H0V15.454z",
  fill: "#FFF"
}));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 37 27",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.35ef7681.svg";
export { ForwardRef as ReactComponent };